function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Helptext from './common/HelpText/HelpText';
import ValidationMessage from './common/ValidationMessage/ValidationMessage';
import { HelpButton } from '../../HelpButton';
import { Text } from '../../Text';
import styles from '@dtsl/css-input/dist/index.module.css';

// eslint-disable-next-line react/display-name
const InputWrapper = /*#__PURE__*/React.memo(props => {
  const {
    label,
    id,
    required,
    isError,
    isSuccess,
    helpText,
    children,
    helpButtonData,
    requiredLabel,
    style,
    validationText,
    className,
    accessibleSuccessText,
    accessibleErrorText
  } = props;
  const helpButtonClasses = classNames({
    [styles['sib-input-label__help-button']]: true,
    [helpButtonData?.className]: !!helpButtonData?.className
  });
  const inputWrapperClasses = classNames({
    [styles['sib-input-wrapper']]: true,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("div", {
    className: inputWrapperClasses,
    style: {
      ...style
    }
  }, !!label && /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: styles['sib-input-label'],
    id: `${id}-label`
  }, /*#__PURE__*/React.createElement(Text, {
    fontFamily: "interactive",
    size: "lg",
    className: styles['sib-input-label-text']
  }, label), requiredLabel ? /*#__PURE__*/React.createElement("span", {
    className: styles['sib-sr-only']
  }, requiredLabel) : null, required ? /*#__PURE__*/React.createElement(Text, {
    fontFamily: "interactive",
    size: "lg",
    color: "var(--sib-color_negative-default)",
    className: styles['sib-input-required'],
    "aria-hidden": "true",
    style: {
      marginLeft: '4px'
    }
  }, "*") : null, helpButtonData ? /*#__PURE__*/React.createElement(HelpButton, _extends({}, helpButtonData, {
    className: helpButtonClasses
  })) : null), /*#__PURE__*/React.createElement(Helptext, {
    helpText: helpText,
    id: id
  }), children, /*#__PURE__*/React.createElement(ValidationMessage, {
    id: id,
    isError: isError,
    isSuccess: isSuccess,
    validationText: validationText,
    accessibleErrorText: accessibleErrorText,
    accessibleSuccessText: accessibleSuccessText
  }));
});
InputWrapper.propTypes = {
  isError: PropTypes.bool,
  isSuccess: PropTypes.bool,
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
  required: PropTypes.bool,
  style: PropTypes.object,
  requiredLabel: (props, propName) => {
    const required = props['required'];
    const requiredLabel = props[propName];
    if (required && !requiredLabel) {
      return new Error(`Warning: 'requiredLabel' prop should be passed when 'required' prop is true.`);
    }
    if (typeof requiredLabel !== 'string') {
      return new Error(`Warning: 'requiredLabel should be a string.`);
    }
  },
  helpText: PropTypes.string,
  helpButtonData: PropTypes.object,
  label: PropTypes.string,
  validationText: PropTypes.string,
  className: PropTypes.string,
  accessibleErrorText: PropTypes.string,
  accessibleSuccessText: PropTypes.string
};
export default InputWrapper;